
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dfgVG", function(module, exports) {

$parcel$export(module.exports, "checkRevertFlag", () => $d6588355bb2f168c$export$37ee5f1519219257);
$parcel$export(module.exports, "addRevertFlag", () => $d6588355bb2f168c$export$1c5c21f47c0c866b);
$parcel$export(module.exports, "removeRevertFlag", () => $d6588355bb2f168c$export$75835fd24886e23f);

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");
const $d6588355bb2f168c$export$37ee5f1519219257 = (contentId)=>{
    return (0, $e9zUf.confluenceSessionStorageInstance)?.getItem((0, $1UApO.keys).EDITOR_REVERTED) === contentId;
};
const $d6588355bb2f168c$export$1c5c21f47c0c866b = (contentId)=>{
    (0, $e9zUf.confluenceSessionStorageInstance)?.setItem((0, $1UApO.keys).EDITOR_REVERTED, contentId);
};
const $d6588355bb2f168c$export$75835fd24886e23f = ()=>{
    (0, $e9zUf.confluenceSessionStorageInstance)?.removeItem((0, $1UApO.keys).EDITOR_REVERTED);
};

});

parcelRegister("6UMDm", function(module, exports) {

$parcel$export(module.exports, "AutoConversionByLineContextProvider", () => $1493c1e4d7d497eb$export$78dcd8ae786efebe);
$parcel$export(module.exports, "useAutoConversionByLineContext", () => $1493c1e4d7d497eb$export$847684e45bf010db);

var $gwFzn = parcelRequire("gwFzn");

var $9wGTI = parcelRequire("9wGTI");

var $dfgVG = parcelRequire("dfgVG");
var $jNUT6 = parcelRequire("jNUT6");
const $1493c1e4d7d497eb$export$f12106fa80cfd400 = /*#__PURE__*/ (0, $gwFzn.createContext)({
    editorProperty: '',
    fabricEditorSupported: false,
    isAutoConverted: false,
    queryDataId: ''
});
const $1493c1e4d7d497eb$export$78dcd8ae786efebe = ({ editorProperty: editorProperty, fabricEditorSupported: fabricEditorSupported, isAutoConverted: isAutoConvertedWithNewTinyPages, queryDataId: queryDataId, children: children })=>{
    const isAutoConverted = (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : !editorProperty && fabricEditorSupported;
    const isFabric = editorProperty === 'v2' || ((0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? isAutoConvertedWithNewTinyPages : isAutoConverted);
    const autoConversionContextValue = (0, $gwFzn.useMemo)(()=>({
            editorProperty: editorProperty,
            fabricEditorSupported: fabricEditorSupported,
            isAutoConverted: isAutoConverted,
            queryDataId: queryDataId
        }), [
        editorProperty,
        fabricEditorSupported,
        isAutoConverted,
        queryDataId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1493c1e4d7d497eb$export$f12106fa80cfd400.Provider, {
        value: autoConversionContextValue
    }, children, !isFabric && queryDataId && (0, $dfgVG.checkRevertFlag)(queryDataId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "auto-editor-conversion-revert-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jNUT6.RevertEditorSuccess), null)));
};
const $1493c1e4d7d497eb$export$847684e45bf010db = ()=>(0, $gwFzn.useContext)($1493c1e4d7d497eb$export$f12106fa80cfd400);

});
parcelRegister("jNUT6", function(module, exports) {

$parcel$export(module.exports, "RevertEditorSuccess", () => $1d10088386de9373$export$b2e4e7debfeba26);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7aRa9 = parcelRequire("7aRa9");

var $dfgVG = parcelRequire("dfgVG");
const $1d10088386de9373$var$i18n = (0, $2nPZH.defineMessages)({
    revertEditorFlagSuccessTitle: {
        id: "editor-conversion.revert-editor.flag.success.title",
        defaultMessage: "Editor reverted"
    },
    revertEditorFlagSuccessBody: {
        id: "editor-conversion.revert-editor.flag.success.body",
        defaultMessage: "It was successfully reverted to the legacy editor for this page."
    }
});
const $1d10088386de9373$export$974b18a34ecfb5af = ({ flags: flags })=>{
    (0, $gwFzn.useEffect)(()=>{
        const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $1d10088386de9373$var$i18n.revertEditorFlagSuccessBody);
        flags.showFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $1d10088386de9373$var$i18n.revertEditorFlagSuccessTitle),
            description: description,
            close: 'auto'
        });
        (0, $dfgVG.removeRevertFlag)();
    }, [
        flags
    ]);
    return null;
};
const $1d10088386de9373$export$b2e4e7debfeba26 = (0, $7aRa9.withFlags)($1d10088386de9373$export$974b18a34ecfb5af);

});



//# sourceMappingURL=RevertEditorDialog.93ded4e3.js.map
